import { render, staticRenderFns } from "./PortabilityCard.vue?vue&type=template&id=d36c6102&scoped=true"
import script from "./PortabilityCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortabilityCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PortabilityCard.vue?vue&type=style&index=0&id=d36c6102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36c6102",
  null
  
)

export default component.exports